import { FieldSet, FillPreview, Input, Text } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { ZIndexContext } from "./../../ricos-context/index.js";
import { toHexFormat } from "./../../ricos-styles/index.js";
import { combineHexWithOpacity, getOpacityFromHex } from "./../../wix-rich-content-common/index.js";
import { SWATCH_TOGGLE } from "./../color-picker/button-color-swatches/data-hooks.js";
import { InputWithSlider } from "./../input-with-slider/input-with-slider.js";
const ColorWithOpacityInput = ({
  color,
  onChange,
  label,
  inputDataHook,
  onColorPress,
  colorPickerRef,
  zIndex,
  fillPreviewDataHook
}) => {
  const zIndexService = useContext(ZIndexContext);
  const hexColor = React.useMemo(() => color ? toHexFormat(color) : void 0, [color]);
  const baseColor = React.useMemo(() => hexColor?.slice(0, 7), [hexColor]);
  const initialOpacity = React.useMemo(() => getOpacityFromHex(hexColor), [hexColor]);
  const [opacity, setOpacity] = useState(initialOpacity);
  React.useEffect(() => {
    const newOpacity = getOpacityFromHex(hexColor);
    if (newOpacity !== opacity) {
      setOpacity(newOpacity);
    }
  }, [hexColor]);
  const handleOpacityChange = React.useCallback(
    (value) => {
      const boundedValue = Math.min(100, Math.max(0, Math.round(value)));
      if (boundedValue === opacity) return;
      setOpacity(boundedValue);
      const newColor = combineHexWithOpacity(baseColor, boundedValue);
      if (hexColor !== newColor && newColor) {
        onChange(newColor);
      }
    },
    [opacity, baseColor, hexColor, onChange]
  );
  return /* @__PURE__ */ React.createElement(
    FieldSet,
    {
      legend: void 0,
      columns: "auto 72px 30px",
      gap: "small",
      alignment: "center",
      infoTooltipProps: {
        appendTo: (el) => Boolean(el.getAttribute("data-hook")?.includes("ricos-portal")),
        zIndex: zIndexService.getZIndex("TOOLTIP")
      },
      dataHook: inputDataHook
    },
    /* @__PURE__ */ React.createElement(Text, { size: "small" }, label),
    /* @__PURE__ */ React.createElement(
      InputWithSlider,
      {
        gradientColor: baseColor,
        value: opacity,
        onChange: (value) => {
          handleOpacityChange(value);
        },
        zIndex,
        suffix: /* @__PURE__ */ React.createElement(Input.Affix, null, "%"),
        min: 0,
        max: 100
      }
    ),
    /* @__PURE__ */ React.createElement(
      FillPreview,
      {
        fill: baseColor,
        onClick: onColorPress,
        ref: colorPickerRef,
        dataHook: fillPreviewDataHook || SWATCH_TOGGLE
      }
    )
  );
};
export {
  ColorWithOpacityInput
};
//# sourceMappingURL=color-with-opacity-input.js.map
